const BronzeAge = {
  id: '2',
  name: 'Bronze Age'
};

export default BronzeAge;
